import { s } from "../lib/constants";

export default function LoadingDots() {
  return (
    <div style={s.dots}>
      <span style={{ ...s.dot, animationDelay: "0s" }} />
      <span style={{ ...s.dot, animationDelay: "0.2s" }} />
      <span style={{ ...s.dot, animationDelay: "0.4s" }} />
    </div>
  );
}
